// --------------------- Import Styles ---------------------
import { Container } from "../ViewGerenciarPostagens/styles";
// --------------------- Import Globais ---------------------
import { useState, useEffect } from "react";
import { useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
// --------------------- Import Antd-Design ---------------------
import {
  Col,
  Flex,
  Row,
  Button,
  MenuProps,
  Skeleton,
  Table,
  Typography,
} from "antd";
import type { TableProps } from "antd/es/table";
// --------------------- Import Material Icon ---------------------
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HomeIcon from "@mui/icons-material/Home";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
// --------------------- Import Uteis ---------------------
import { usePermissao } from "../../uteis/permissaoAdm/usePermissao";
import { Columns } from "./components/Columns";
import { useBuscarEtiquetas } from "./hooks/useBuscarEtiquetas";
import ModalAdicionar from "./components/ModalAdicionar";
import ModalEditar from "./components/ModalEditar";
import ModalExcluir from "./components/ModalExcluir";
// import ModalLead from "./components/ModalLead";
// ---------------------  ---------------------

export default function ViewGerenciarEtiquetas() {
  const navigate = useNavigate();
  // Traz o estilo Title da biblioteca
  const { Title } = Typography;
  const isMobile = useMediaQuery("(max-width:600px)");

  // Verificação de permissão do usuário, NDA = 0 - SEM PERMISSÃO, NDA = 1 - COM PERMISSÃO
  // Definação do Loading caso seja permitido
  const { isLoading: isTokenLoading, isValid } = usePermissao("OPE");

  // Controle de Paginação
  const [currentPage, setCurrentPage] = useState(1);

  // Armazena o valor da origem da Etiqueta
  const [etiquetaId, setEtiquetaId] = useState<number | null>(null);

  // Armazena o valor da origem da lead
  const [leadId, setLeadId] = useState<number | null>(null);

  const { etiquetas, isLoading } = useBuscarEtiquetas();

  // Inicializando o filtro
  const [filteredInfo, setFilteredInfo] = useState<{
    nome?: string[] | null;
    descricao?: string[] | null;
    cor?: string[] | null;
    createAt?: string[] | null;
  }>({
    nome: null,
    descricao: null,
    cor: null,
    createAt: null,
  });

  const [semFiltros, setSemFiltros] = useState(true);

  useEffect(() => {
    const filtros = localStorage.getItem("filtrosPropriedades");
    const pagina = localStorage.getItem("pageGerPropriedades");

    if (filtros) {
      const novoFiltro = JSON.parse(filtros);
      setFilteredInfo({
        nome: novoFiltro.nome ? [novoFiltro.nome] : null,
        descricao: novoFiltro.descricao ? [novoFiltro.descricao] : null,
        cor: novoFiltro.cor ? [novoFiltro.cor] : null,
        createAt: novoFiltro.createAt ? [novoFiltro.createAt] : null,
      });
      setSemFiltros(false);
    }

    if (pagina) {
      setCurrentPage(Number(pagina));
    }
  }, []);

  const onChange: TableProps<any>["onChange"] = (pagination, filters) => {
    setFilteredInfo({
      nome: filters.nome as string[] | null,
      descricao: filters.descricao as string[] | null,
      cor: filters.cor as string[] | null,
      createAt: filters.createAt as string[] | null,
    });

    const hasFilters = Boolean(
      filters.nome || filters.descricao || filters.cor || filters.createAt
    );
    setSemFiltros(!hasFilters);

    if (pagination.current) {
      localStorage.setItem(
        "pageGerPropriedades",
        pagination.current.toString()
      );
    }

    localStorage.setItem("filtrosPropriedades", JSON.stringify(filters));
  };

  const removerFiltros = () => {
    localStorage.removeItem("filtrosPropriedades");
    localStorage.removeItem("pageGerPropriedades");

    setFilteredInfo({
      nome: null,
      descricao: null,
      cor: null,
      createAt: null,
    });
    setSemFiltros(true);
    setCurrentPage(1);
  };

  const handleFilter = () => {
    removerFiltros();
  };

  // OnClick das opções e funções que serão realizadas do item Ações
  const onClick: MenuProps["onClick"] = async ({ key }) => {
    switch (key) {
      // Editar
      case "1":
        editarModal();
        break;

      case "2":
        // Excluir
        excluirModal();
        break;
      case "3":
        // Ver Pessoas

        navigate("/gerenciarEtiquetaPessoa", {
          state: { etiquetaId: etiquetaId },
        });

        break;
    }
  };

  // Traz as informações  OnClick, origem , nome e id do apartamento além do nome do empreendimento, ao clickar na linha especifica
  const columns = Columns(onClick, setEtiquetaId, {
    nome: filteredInfo.nome,
    descricao: filteredInfo.descricao,
    cor: filteredInfo.cor,
    createAt: filteredInfo.createAt,
  });

  // State de abertura e fechamento do modal (Adicionar Lead)
  const [isModalAdicionarOpen, setIsModalAdicionarOpen] = useState(false);

  // Funçao para abrir o modal (Adicionar Apartamento)
  const adicionarModal = () => {
    setIsModalAdicionarOpen(true);
  };

  // Funçao para fechar o modal (Editar Adicionar)
  const handleAdicionarFechar = () => {
    setIsModalAdicionarOpen(false);
  };

  // State de abertura e fechamento do modal (Editar Lead)
  const [isModalEditarOpen, setIsModalEditarOpen] = useState(false);

  // Funçao para abrir o modal (Editar Apartamento)
  const editarModal = () => {
    setIsModalEditarOpen(true);
  };

  // Funçao para fechar o modal (Editar Apartamento)
  const handleEditarFechar = () => {
    setIsModalEditarOpen(false);
  };

  // State de abertura e fechamento do modal (Excluir Lead)
  const [isModalExcluirOpen, setIsModalExcluirOpen] = useState(false);

  // Funçao para abrir o modal (Editar Lead)
  const excluirModal = () => {
    setIsModalExcluirOpen(true);
  };

  // Funçao para fechar o modal (Excluir Lead)
  const handleExcluirFechar = () => {
    setIsModalExcluirOpen(false);
  };

  // State de abertura e fechamento do modal (Ver Lead)
  const [isModalLeadOpen, setIsModalLeadOpen] = useState(false);

  // Funçao para abrir o modal (Ve Lead)
  const leadModal = () => {
    setIsModalLeadOpen(true);
  };

  // Funçao para fechar o modal (Ver Lead)
  const handleLeadFechar = () => {
    setIsModalLeadOpen(false);
  };

  return (
    <>
      {(isLoading && isTokenLoading) || !isValid ? (
        <Skeleton active />
      ) : (
        <Container>
          <Row>
            <Col span={5}>
              <Flex align="center" justify="center" style={{ marginTop: 15 }}>
                <a href={`/inicio`}>
                 
                </a>
              </Flex>
            </Col>
            <Col span={12}>
              <Flex align="center" justify="center">
                <HomeIcon color="primary" fontSize="large" />
                <Title
                  style={{
                    marginLeft: 10,
                    marginTop: 10,
                    fontSize: isMobile ? "1rem" : "2rem",
                    color: "rgb(0, 54, 68)",
                  }}
                  level={3}
                >
                  Gerenciar Etiquetas
                </Title>
              </Flex>
            </Col>
          </Row>
          <Row>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end", // Alinha o conteúdo à direita
                alignItems: "center",
                height: "auto",
                width: "90%", // Garante que ocupe toda a largura disponível
                gap: "20px", // Espaço entre os botões
              }}
            >
              <Button
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "auto",
                }}
                onClick={() => {
                  adicionarModal();
                }}
                type="primary"
              >
                + Etiqueta
              </Button>

              {semFiltros ? (
                <Button onClick={handleFilter} type="primary" disabled={true}>
                  <FilterAltIcon />
                </Button>
              ) : (
                <Button onClick={handleFilter} type="primary">
                  <FilterAltOffIcon />
                </Button>
              )}
            </div>

            <Col span={isMobile ? 5 : 1}></Col>
            <Col
              span={22}
              style={{
                marginTop: isMobile ? 15 : 15,
                marginBottom: isMobile ? 30 : 50,
              }}
            >
              <Flex
                style={{
                  width: isMobile ? "auto" : "100%",
                  overflow: "auto",
                  marginLeft: 30,
                }}
              >
                <Table
                  rowKey={(record) => record.id || record.key || Math.random()}
                  columns={columns}
                  dataSource={etiquetas}
                  onChange={onChange}
                  bordered
                  style={{
                    alignItems: "center",
                    justifyContent: "center",
                    width: isMobile ? "auto" : "100%",
                    maxWidth: isMobile ? "none" : "100%",
                  }}
                  pagination={{ defaultCurrent: currentPage }}
                />
              </Flex>
            </Col>
            <Col span={1}></Col>
          </Row>
          <ModalAdicionar
            isModalOpen={isModalAdicionarOpen}
            handleFechar={handleAdicionarFechar}
          />
          <ModalEditar
            isModalOpen={isModalEditarOpen}
            handleFechar={handleEditarFechar}
            etiquetaId={etiquetaId}
          />
          <ModalExcluir
            isModalOpen={isModalExcluirOpen}
            handleFechar={handleExcluirFechar}
            etiquetaId={etiquetaId}
          />
          {/* <ModalLead
            isModalOpen={isModalLeadOpen}
            handleFechar={handleLeadFechar}
            leadId={leadId}
          /> */}
        </Container>
      )}
      ;
    </>
  );
}
